import React from "react";

const Options = ({options}) => {
   //console.log("Options", options, defaults)
    const model = options.map( (o, i) => {
        const option = (o.value && o.label) ?
            o :
            (o.value) ?
                {value:o.value, label:o.value} :
                {value:o, label:o}
        return option
    })
    return model.map( (o, i) => {
        return <option value={o.value} key={i}>{o.label}</option>
    })
}

export default Options